import LogoOnlyHeader from './LogoOnlyHeader'

export default LogoOnlyHeader
export { LogoOnlyHeader }
